import "./src/styles/tailwind.css"
import "typeface-fira-sans"
